<template>
  <router-link
    :to="!disabled ? url : ''"
    class="whitespace-nowrap text-center inline-block font-medium rounded border transition-all"
    :class="[buttonSize, buttonType, { disabled: disabled }]"
    v-if="isInternal"
  >
    {{ buttonText }}
  </router-link>
  <a
    :href="!disabled ? url : ''"
    target="_blank"
    class="text-center whitespace-nowrap inline-block font-medium rounded border transition-all"
    :class="[buttonSize, buttonType, { disabled: disabled }]"
    v-else
  >
    {{ buttonText }}</a
  >
</template>
<script>
export default {
  props: {
    buttonText: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'primary'
    },
    url: {
      required: true
    },
    linkType: {
      type: String,
      default: 'internal'
    },
    size: {
      type: String,
      default: 'regular'
    }
  },
  data: () => ({
    buttonClass: {
      primary: 'bg-primary-400 text-white border-primary-400 hover:bg-primary-700 hover:border-primary-700',
      secondary: 'bg-transparent border-primary-400 text-primary-400 hover:border-primary-700 hover:text-primary-700',
      tertiary: ''
    },
    buttonCLassSize: {
      full: 'w-full py-2 px-6 text-base',
      regular: 'py-2 px-6 text-base',
      small: 'py-1 px-3 text-sm',
      big: 'text-base py-3 px-6',
      big_full: 'w-full text-base py-3 px-6'
    }
  }),
  computed: {
    buttonType() {
      return this.buttonClass[this.type]
    },
    buttonSize() {
      return this.buttonCLassSize[this.size]
    },
    isInternal() {
      return this.linkType === 'internal'
    }
  }
}
</script>
<style lang="scss" scoped>
.disabled {
  background-color: #d6d6d6;
  color: #fff;
  border-color: #d6d6d6;
  cursor: not-allowed;
}
</style>
